import {Module} from 'module/Module'
import {ClipboardReducerNS} from 'module/Clipboard/reducer/ClipboardReducer'

// epic implemented in GenCFDefChangeEventHandlerEpic
export const ClipboardModule: Module = {
	reducerNS: ClipboardReducerNS,
}